import React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import 'semantic-ui-css/semantic.min.css';
import 'react-day-picker/lib/style.css';
// Import global CSS
import './styles/colors.css';
import './styles/layout.css';
import './styles/typography.css';
import './index.css';
import Root from './root/components/Root';

axios.defaults.headers.common = {
  'Content-Type': 'application/json',
  Accept: 'application/json',
};
// import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
